<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('WorkHourDiaryList') | ToUppercase">
                <vs-button class="float-left" color="success" type="filled" to="/report/workHourDiary/add">{{$t('AddWorkHourDiary')}}</vs-button>

                <vs-table :noDataText="$t('NoReportsFound')" max-items="14" pagination search :data="workHourDiaries">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th sort-key="name">{{ $t("Name") }}</vs-th>
                        <vs-th>{{ $t("Actions") }}</vs-th>
                        <vs-th>{{ $t("Download") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].name}}</vs-td>
                                <vs-td>
                                    <vs-button color="primary" class="float-left mr-2" @click="$router.push('/report/workHourDiary/edit/' + data[index].id)" type="border" icon="build" >{{$t('Edit') | ToUppercase}}</vs-button>
                                    <vs-button v-if="admin == 'admin'" color="primary" class="float-left" @click="deleteReport(data[index].id)" type="border" icon="delete" >{{$t('Delete') | ToUppercase}}</vs-button>
                                </vs-td>
                                <vs-td class="grid justify-items-start">
                                    <vs-button class="float-left mr-2" v-if="data[index].excel_name != ''" color="primary" @click="excelClick(data[index].excel_name)" type="border" icon="table_chart">EXCEL</vs-button>
                                    <vs-button class="float-left" v-if="data[index].pdf_name != ''" color="primary" @click="pdfClick(data[index].pdf_name)" type="border" icon="picture_as_pdf">PDF</vs-button>
                                </vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
            Datepicker
        },
        data() {
            return {
                workHourDiaries: [],
                admin: '',
            };
        },
        methods: {
            updateWorkHourDiaries() {
                this.$vs.loading();
                const thisIns = this;
                this.$http.get('/report?type=workHourDiaryReport')
                .then(function (response) {
                    thisIns.workHourDiaries = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            deleteReport(id) {
                this.$vs.loading();
                
                const thisIns = this;
                this.$http.delete('/report/' + id + '?type=workHourDiaryReport')
                .then(function (response) {
                    thisIns.updateWorkHourDiaries();

                    thisIns.$vs.notify({
                        text: "Poročilo izbrisano",
                        color: "success",
                    });
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri brisanju poročila",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            },
            excelClick(excelName) {
                window.open('/api/excel/report/' + excelName + '?type=workHourDiary');
            },
            pdfClick(pdfName){
                window.open('/api/pdf/report/' + pdfName + '?type=workHourDiary');
            },
        },
        created() {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.userId = userInfo.uid;
            this.admin = userInfo.userRole;

            this.updateWorkHourDiaries();
        },
    };
</script>